export const focusUnfocusableElement = (element: HTMLElement) => {
  element.setAttribute("tabindex", "-1");
  element.focus({ preventScroll: true });
  element.addEventListener("blur", () => element.removeAttribute("tabindex"), {
    once: true,
  });
};
